export default __webpack_public_path__ + "static/media/compliance-image.eadeb836.webp";